module.exports = __webpack_public_path__ + "img/024.a4ccc525.png";